exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cards-summary {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n.cards-summary .card {\n  flex: 1;\n  border-radius: 8px;\n  padding: 1rem;\n  color: #fff;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.05);\n}\n.cards-summary .card h3 {\n  font-size: 1rem;\n  margin-bottom: 0.5rem;\n}\n.cards-summary .card p {\n  font-size: 1.4rem;\n  font-weight: bold;\n}\n.cards-summary .card.total {\n  background: #0d3b66;\n}\n.cards-summary .card.chatbot {\n  background: #9da8b2;\n}\n.cards-summary .card.aguardando {\n  background: #be1724; \n  color: #333;\n}\n.cards-summary .card.em-atendimento {\n  background: #2e7d32;\n}\n", ""]);

// exports
